import React, { useState } from 'react';
import * as yup from 'yup';
import { urlValidation } from '../../utils/formikValidations';
import { getFieldType } from '../../utils/formik';
import { updateCompany } from '../API/company';
import { useSnackbarContext } from '../../contexts/Snackbar';
import { useHistory } from 'react-router-dom';
import { isEqual } from 'lodash';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import { Form, Formik } from 'formik';
import SubmitButton from '../SubmitButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Field } from 'formik';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  questions: { marginTop: theme.spacing(3) },
  question: { display: 'block', width: 400, marginBottom: theme.spacing(2) },
  error: { marginTop: theme.spacing(2) },
}));

let questions = [
  { question: 'Name', value: 'name', type: 'string' },
  { question: 'Store URL', value: 'storeUrl', type: 'url' },
];

export default function EditBusiness({ company }) {
  const classes = useStyles();
  const history = useHistory();
  const snackbar = useSnackbarContext();
  const [error, setError] = useState(null);

  const initialValues = {
    name: company.name || '',
    storeUrl: company.storeUrl ? company.storeUrl : '',
  };

  return (
    <Container className={classes.root}>
      {company && (
        <Formik
          initialValues={initialValues}
          validationSchema={yup.object({
            name: yup.string().required(),
            storeUrl: urlValidation,
          })}
          onSubmit={async (values) => {
            const nothingChanged = isEqual(initialValues, values);
            if (nothingChanged) {
              setError('Nothing has changed.');
              return setTimeout(() => setError(null), 3000);
            }
            try {
              const businessInfo = {
                name: values.name,
                store_url: values.storeUrl,
              };
              await updateCompany(businessInfo);
              snackbar.show('Business successfully updated.', 'success');
              setTimeout(() => history.push('/account'), 500);
            } catch (error) {
              console.log(error.message);
              snackbar.show(
                'We encountered an error while trying to update your business. Please try again.',
                'error',
              );
            }
          }}
        >
          {({ isSubmitting }) => {
            return (
              <Form>
                <div className={classes.questions}>
                  {questions.map((question) => {
                    const fieldType = getFieldType(question.type);
                    return (
                      <Field
                        key={question.question}
                        fullWidth
                        component={fieldType}
                        name={question.value}
                        label={question.question}
                        variant="outlined"
                        className={classes.question}
                      />
                    );
                  })}
                </div>
                <SubmitButton isSubmitting={isSubmitting} text="Save" />
                <FormHelperText error className={classes.error}>
                  {error}
                </FormHelperText>
              </Form>
            );
          }}
        </Formik>
      )}
    </Container>
  );
}
